var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeglauWrmepumpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    height: 39.694,
    viewBox: "0 0 150 39.694",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_193",
    "data-name": "Rectangle 193",
    width: 150,
    height: 39.694,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_01_white",
    "data-name": "logo 01 white",
    transform: "translate(75 19.847)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_01_white-2",
    "data-name": "logo 01 white",
    transform: "translate(-75 -19.847)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M76.719,156.3H41.312a.314.314,0,0,0-.314.314v.444a.314.314,0,0,0,.3.333l35.444,2.68h.018a.314.314,0,0,0,.314-.314v-3.142a.314.314,0,0,0-.314-.314",
    transform: "translate(-33.421 -127.416)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M3.328,192.926l-2.033.185a.314.314,0,0,0-.3.3v3.142a.314.314,0,0,0,.314.314h0l2.569-.037a.314.314,0,0,0,.314-.37l-.517-3.289a.314.314,0,0,0-.351-.277",
    transform: "translate(-0.815 -157.242)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M20.993,186.464a.314.314,0,0,0-.388-.055l-1.2.721a.314.314,0,0,0-.148.351l1.035,3.807a.314.314,0,0,0,.314.24h4.712a.314.314,0,0,0,.222-.536Z",
    transform: "translate(-15.689 -151.925)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M50.392,182.85l-18.129-6.339a.314.314,0,0,0-.351.092l-.684.813a.314.314,0,0,0,.037.462l7.059,5.525a.314.314,0,0,0,.2.074H50.281a.319.319,0,1,0,.111-.628",
    transform: "translate(-25.389 -143.876)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M74.94,170.636l-35.555-4.454a.314.314,0,0,0-.351.222l-.185.628a.314.314,0,0,0,.222.388l26.648,7.632H74.9a.314.314,0,0,0,.314-.314V170.95a.314.314,0,0,0-.277-.314",
    transform: "translate(-31.66 -135.469)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M10.256,26.322H0V2.889H9.129a13.176,13.176,0,0,1,4.1.573A6.1,6.1,0,0,1,15.837,5,6.061,6.061,0,0,1,17.408,9.08a4.774,4.774,0,0,1-1.774,4.084,6.394,6.394,0,0,1-.85.591l-.832.388A6.109,6.109,0,0,1,17.426,16.1a5.454,5.454,0,0,1,1.294,3.7,6.3,6.3,0,0,1-1.682,4.324Q15.1,26.3,10.275,26.3M5.23,12.369H7.706a8.509,8.509,0,0,0,3.234-.462,1.976,1.976,0,0,0,1.053-2.033,2.119,2.119,0,0,0-.979-2.07,7.366,7.366,0,0,0-3.271-.5H5.23Zm0,9.517H8.815a7.909,7.909,0,0,0,3.363-.554,2.191,2.191,0,0,0,1.127-2.181,2.094,2.094,0,0,0-1.183-2.144,10.208,10.208,0,0,0-3.807-.517H5.23Z",
    transform: "translate(0 -2.353)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M159.99,2.9V7.557H148.33V12.38h10.478v4.454H148.33v4.86h12.03v4.638H143.1V2.9Z",
    transform: "translate(-116.656 -2.364)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M289.139,12.03h5.267v8.316q-3.493,3.881-9.646,3.881a11.941,11.941,0,0,1-8.667-3.419,11.477,11.477,0,0,1-3.493-8.63A12.022,12.022,0,0,1,284.778,0a12.7,12.7,0,0,1,8.759,3.326l-2.717,3.918a10.264,10.264,0,0,0-2.9-1.885,7.78,7.78,0,0,0-2.864-.536,6.867,6.867,0,0,0-5.027,2.033A7.126,7.126,0,0,0,278,12.2a7.205,7.205,0,0,0,1.959,5.3,6.32,6.32,0,0,0,4.675,2,9.017,9.017,0,0,0,4.528-1.035Z",
    transform: "translate(-222.224 0)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M434,26.332V2.9h5.211V21.657h10v4.675Z",
    transform: "translate(-353.798 -2.364)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M558.336,26.332l-2.181-5.063h-9.813l-2.181,5.063H538.6L548.708,2.9h5.063L563.9,26.332ZM551.259,9.885l-2.957,6.8h5.858Z",
    transform: "translate(-439.068 -2.364)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M709.542,20.271a4.28,4.28,0,0,0,3.511,1.626,4.229,4.229,0,0,0,3.493-1.626,6.936,6.936,0,0,0,1.294-4.435V2.9h5.23V16q0,5.1-2.809,7.817a10.86,10.86,0,0,1-14.433-.018Q703,21.047,703,16V2.9h5.23V15.836a6.868,6.868,0,0,0,1.312,4.435",
    transform: "translate(-573.087 -2.364)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M2.382,162.556l-2.088.185a.314.314,0,0,0-.3.314v3.179a.316.316,0,0,0,.314.333H2.9a.314.314,0,0,0,.24-.111.37.37,0,0,0,.092-.277l-.517-3.326a.314.314,0,0,0-.314-.277H2.363m2.439-1.2-1.22.721a.314.314,0,0,0-.148.351l1.053,3.862a.333.333,0,0,0,.314.259H9.552a.314.314,0,0,0,.3-.2.351.351,0,0,0-.074-.37L5.191,161.41a.314.314,0,0,0-.222-.092l-.166.037M6.429,159.6l-.7.813a.314.314,0,0,0,.037.462l7.115,5.618a.314.314,0,0,0,.2.074H24.927a.351.351,0,0,0,.314-.314.314.314,0,0,0-.2-.351L6.78,159.507H6.669a.314.314,0,0,0-.24.111m.85-1.811-.185.628a.314.314,0,0,0,.222.407l26.833,7.725h9.258a.314.314,0,0,0,.314-.314v-3.881a.314.314,0,0,0-.277-.314L7.612,157.566H7.575a.314.314,0,0,0-.314.222m.517-2.088a.333.333,0,0,0-.314.314v.444a.314.314,0,0,0,.3.333l35.629,2.68h.018a.314.314,0,0,0,.314-.314v-3.142a.314.314,0,0,0-.314-.314Z",
    transform: "translate(0.002 -126.927)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M279.1,174.566a.2.2,0,0,1,.222-.166h.222a.222.222,0,0,1,.2.2v.129L278.3,181.5a.351.351,0,0,1-.092.185.3.3,0,0,1-.185.055h-.166a.314.314,0,0,1-.333-.259l-1.4-4.435-1.4,4.435a.314.314,0,0,1-.333.259h-.166a.3.3,0,0,1-.185-.055.351.351,0,0,1-.092-.185l-1.441-6.764V174.6a.222.222,0,0,1,.2-.2h.222a.225.225,0,0,1,.24.166l1.22,5.987,1.294-4.269a.314.314,0,0,1,.333-.24h.24a.314.314,0,0,1,.333.24l1.294,4.269Z",
    transform: "translate(-222.143 -142.171)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M328.194,173.811l-.647,1.682-.074.111a.222.222,0,0,1-.148.055H327.1a.222.222,0,0,1-.2-.2v-.111l2.661-6.8a.3.3,0,0,1,.3-.2h.351a.314.314,0,0,1,.3.2l2.661,6.8v.111a.222.222,0,0,1-.2.2h-.2a.222.222,0,0,1-.148-.055l-.074-.111-.647-1.682Zm3.456-.628-1.608-4.139-1.608,4.139Zm-2.2-5.47a.24.24,0,0,1-.166.055h-.407a.222.222,0,0,1-.222-.222v-.407a.24.24,0,0,1,.055-.166.222.222,0,0,1,.166-.074h.407a.24.24,0,0,1,.24.24v.407a.222.222,0,0,1-.074.166m1.922,0a.24.24,0,0,1-.166.055H330.8a.222.222,0,0,1-.222-.222v-.407a.24.24,0,0,1,.055-.166.222.222,0,0,1,.166-.074h.407a.24.24,0,0,1,.24.24v.407a.222.222,0,0,1-.074.166",
    transform: "translate(-266.49 -136.057)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M384.734,175.036a1.945,1.945,0,0,1,.647,1.589,1.882,1.882,0,0,1-1.589,2.014l1.682,2.883a.258.258,0,0,1,.037.111.222.222,0,0,1-.2.2h-.129a.351.351,0,0,1-.24-.074.832.832,0,0,1-.166-.222l-1.663-2.827h-2.162v2.9a.222.222,0,0,1-.074.166.24.24,0,0,1-.166.055h-.185a.222.222,0,0,1-.222-.222V174.74a.24.24,0,0,1,.055-.166.222.222,0,0,1,.166-.074h2.439a2.7,2.7,0,0,1,1.774.536M382.9,178.1a2.155,2.155,0,0,0,1.367-.37,1.29,1.29,0,0,0,.444-1.109,1.361,1.361,0,0,0-.444-1.109,2.108,2.108,0,0,0-1.367-.37h-1.959V178.1Z",
    transform: "translate(-310.02 -142.253)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M432.393,180.077h-.222a.333.333,0,0,1-.333-.2l-2-3.936v5.673a.222.222,0,0,1-.222.222h-.185a.24.24,0,0,1-.166-.055.222.222,0,0,1-.074-.166v-6.874a.222.222,0,0,1,.074-.185.24.24,0,0,1,.166-.055h.259a.222.222,0,0,1,.222.129l2.384,4.638,2.384-4.638a.24.24,0,0,1,.222-.129h.259a.222.222,0,0,1,.24.24v6.874a.222.222,0,0,1-.074.166.24.24,0,0,1-.166.055h-.185a.222.222,0,0,1-.222-.222v-5.692l-2,3.936a.333.333,0,0,1-.333.2",
    transform: "translate(-349.881 -142.249)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M490.48,181.278a.24.24,0,0,1,.055.185v.166a.222.222,0,0,1-.074.166.24.24,0,0,1-.166.055h-4.176a.2.2,0,0,1-.222-.222v-6.893a.241.241,0,0,1,.055-.166.222.222,0,0,1,.166-.074H490.2a.222.222,0,0,1,.24.24v.166a.222.222,0,0,1-.074.166.24.24,0,0,1-.166.055h-3.659v2.68h3.437a.222.222,0,0,1,.24.24v.166a.222.222,0,0,1-.074.166.24.24,0,0,1-.166.055h-3.437V181.2h3.751a.24.24,0,0,1,.185.055",
    transform: "translate(-396.104 -142.249)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M536.544,175.054a2.322,2.322,0,0,1,0,3.215,2.637,2.637,0,0,1-1.774.554h-2.125V181.6a.222.222,0,0,1-.074.166.24.24,0,0,1-.166.055h-.185A.222.222,0,0,1,532,181.6V174.74a.24.24,0,0,1,.055-.166.222.222,0,0,1,.166-.074h2.55a2.637,2.637,0,0,1,1.774.554m-1.829,3.16a2,2,0,0,0,1.349-.388,1.682,1.682,0,0,0,0-2.291,2,2,0,0,0-1.349-.388h-2.07v3.086Z",
    transform: "translate(-433.686 -142.253)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M584.522,174.552a.24.24,0,0,1,.166-.055h.185a.222.222,0,0,1,.166.074.24.24,0,0,1,.055.166v4.269a3.124,3.124,0,0,1-.684,2.218,2.622,2.622,0,0,1-2,.721,2.685,2.685,0,0,1-2.014-.721,3.07,3.07,0,0,1-.7-2.218v-4.269a.24.24,0,0,1,.055-.166.222.222,0,0,1,.166-.074h.185a.222.222,0,0,1,.24.24v4.287a2.435,2.435,0,0,0,.536,1.719,1.974,1.974,0,0,0,1.515.573,1.949,1.949,0,0,0,1.5-.573,2.435,2.435,0,0,0,.536-1.719v-4.287a.222.222,0,0,1,.074-.185",
    transform: "translate(-472.572 -142.249)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M635.114,180.077h-.24a.333.333,0,0,1-.333-.2l-2-3.936v5.673a.222.222,0,0,1-.222.222h-.185a.24.24,0,0,1-.166-.055.222.222,0,0,1-.074-.166v-6.874a.223.223,0,0,1,.24-.24h.259a.222.222,0,0,1,.222.129L635,179.264l2.384-4.638a.24.24,0,0,1,.222-.129h.259a.222.222,0,0,1,.24.24v6.874a.222.222,0,0,1-.074.166.24.24,0,0,1-.166.055h-.185a.222.222,0,0,1-.222-.222v-5.692l-2.033,3.955a.333.333,0,0,1-.333.2",
    transform: "translate(-515.125 -142.249)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M693.226,175.054a2.322,2.322,0,0,1,0,3.215,2.638,2.638,0,0,1-1.774.554h-2.107V181.6a.222.222,0,0,1-.074.166.24.24,0,0,1-.166.055h-.185a.222.222,0,0,1-.222-.222V174.74a.24.24,0,0,1,.055-.166.222.222,0,0,1,.166-.074h2.55a2.638,2.638,0,0,1,1.774.554m-1.83,3.16a2,2,0,0,0,1.349-.388,1.682,1.682,0,0,0,0-2.291,2,2,0,0,0-1.349-.388h-2.07v3.086Z",
    transform: "translate(-561.429 -142.253)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M741.382,181.278a.24.24,0,0,1,.055.185v.166a.222.222,0,0,1-.074.166.241.241,0,0,1-.166.055H737.02a.222.222,0,0,1-.222-.222v-6.893a.24.24,0,0,1,.055-.166.222.222,0,0,1,.166-.074H741.1a.222.222,0,0,1,.24.24v.166a.222.222,0,0,1-.074.166.24.24,0,0,1-.166.055h-3.659v2.68h3.437a.222.222,0,0,1,.24.24v.166a.222.222,0,0,1-.074.166.24.24,0,0,1-.166.055h-3.437V181.2H741.2a.24.24,0,0,1,.185.055",
    transform: "translate(-600.64 -142.249)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M783.545,181.611a.222.222,0,0,1-.074.166.24.24,0,0,1-.166.055h-.185a.222.222,0,0,1-.222-.222v-6.874a.24.24,0,0,1,.055-.166.222.222,0,0,1,.166-.074h.222a.259.259,0,0,1,.222.129l3.881,5.914v-5.8a.24.24,0,0,1,.055-.166.222.222,0,0,1,.166-.074h.185a.222.222,0,0,1,.24.24v6.856a.24.24,0,0,1-.055.166.222.222,0,0,1-.166.074h-.222a.258.258,0,0,1-.222-.129l-3.862-5.9Z",
    transform: "translate(-638.221 -142.249)",
    fill: "#c9c9c9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeglauWrmepumpen);
export default __webpack_public_path__ + "static/media/BeglauWärmepumpen.64080bbe55f3d2c8dfe0396a7975ef14.svg";
export { ForwardRef as ReactComponent };